import _get from "lodash/get";
import { getSubscription, State as SubscriptionState } from "./subscriptionsSelectors";
import { CustomerType } from "../../../../../constants";
import { ICartSubscriptionPhoneNumber, ICartSubscriptionPhoneNumberCheck } from "../../../../../models";

export type State = SubscriptionState;
export const getPhoneNumber: (state: State, subscriptionId?: string) => Partial<ICartSubscriptionPhoneNumber> = (
    state,
    subscriptionId,
) => _get(getSubscription(state, subscriptionId), "phoneNumber", {});

export const getSelectedPhoneNumber: (state: State, subscriptionId?: string) => string = (state, subscriptionId) =>
    getPhoneNumber(state, subscriptionId).selectedPhoneNumber || "";

export const getPhoneNumberCheck: (
    state: State,
    subscriptionId?: string,
) => Partial<ICartSubscriptionPhoneNumberCheck> = (state, subscriptionId) =>
    getPhoneNumber(state, subscriptionId).check || {};

export const getPhoneNumberCheckIsAllowedToProceed: (state: State, subscriptionId?: string) => boolean = (
    state,
    subscriptionId,
) => _get(getPhoneNumberCheck(state, subscriptionId), "isAllowedToProceed") === true;

export const getPhoneNumberCheckType: (state: State, subscriptionId?: string) => CustomerType | undefined = (
    state,
    subscriptionId,
) => getPhoneNumberCheck(state, subscriptionId).type;
